/* flatoo shared list navigation: native touch swiping, optional desktop arrows. */
(function(){
 'use strict';
 function track(root){return root&&(root.querySelector('.halo-block-content > .products-grid') || root.querySelector('[data-flatoo-native-track]'));}
 function refresh(root){
   var el=track(root);if(!el)return;
   var max=Math.max(0,el.scrollWidth-el.clientWidth);
   var x=el.scrollLeft;
   root.setAttribute('data-flatoo-scroll-overflow',max>2?'true':'false');
   root.querySelectorAll('[data-flatoo-swipe-direction]').forEach(function(btn){
     btn.disabled=Number(btn.dataset.flatooSwipeDirection)<0?x<=2:x>=max-2;
   });
 }
 document.addEventListener('click',function(e){
   var button=e.target.closest('[data-flatoo-swipe-direction]');
   if(!button)return;
   var root=button.closest('.flatoo-native-product-swipe'),el=track(root);
   if(!el)return;
   var item=el.querySelector(':scope > .product, :scope > .flatoo-purpose-furniture__card');
   var gap=parseFloat(getComputedStyle(el).columnGap)||0;
   var step=item?item.getBoundingClientRect().width+gap:el.clientWidth*.8;
   var move=Math.max(step,el.clientWidth-step);
   el.scrollBy({left:Number(button.dataset.flatooSwipeDirection)*move,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
 });
 document.addEventListener('scroll',function(e){
   if(e.target&&e.target.matches&&e.target.matches('.flatoo-native-product-swipe .halo-block-content > .products-grid')){
     refresh(e.target.closest('.flatoo-native-product-swipe'));
   }
 },true);
 function refreshAll(){document.querySelectorAll('.flatoo-native-product-swipe').forEach(refresh);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refreshAll,{once:true});
 else refreshAll();
 window.addEventListener('resize',refreshAll);
 document.addEventListener('shopify:section:load',refreshAll);
})();


/* flatoo complementary PDP native rail v3.
   No Slick dependency; async product recommendations are rendered by theme. */
(function(){
 'use strict';
 var states=new WeakMap(),queued=false;
 var selector='#complementary-product-data.flatoo-same-category-section';
 function refresh(root,track){
   if(!track||!track.isConnected)return;
   var end=Math.max(0,track.scrollWidth-track.clientWidth),x=track.scrollLeft;
   root.dataset.flatooCanScroll=end>3?'true':'false';
   root.querySelectorAll('[data-flatoo-popular-direction]').forEach(function(btn){
     btn.disabled=Number(btn.dataset.flatooPopularDirection)<0?x<3:x>=end-3;
   });
 }
 function install(root){
   var track=root.querySelector('.flatoo-same-category-native-track');
   if(!track)return;
   var existing=states.get(root);
   if(existing===track){refresh(root,track);return;}
   states.set(root,track);
   var dragging=null,lastClickBlock=0;
   track.addEventListener('scroll',function(){refresh(root,track);},{passive:true});
   track.addEventListener('pointerdown',function(ev){
     if(ev.pointerType!=='mouse'||ev.button!==0||!ev.isPrimary||track.scrollWidth<=track.clientWidth+3)return;
     if(ev.target.closest('button,input,select,textarea,[role="button"]'))return;
     dragging={id:ev.pointerId,x:ev.clientX,y:ev.clientY,left:track.scrollLeft,moved:false};
   },{passive:true});
   track.addEventListener('pointermove',function(ev){
     if(!dragging||ev.pointerId!==dragging.id)return;
     var dx=ev.clientX-dragging.x,dy=ev.clientY-dragging.y;
     if(!dragging.moved){
       if(Math.abs(dx)<6||Math.abs(dx)<Math.abs(dy)*1.2)return;
       dragging.moved=true;
       track.classList.add('is-flatoo-dragging');
       try{track.setPointerCapture(ev.pointerId);}catch(e){}
     }
     if(ev.cancelable)ev.preventDefault();
     track.scrollLeft=dragging.left-dx;
   },{passive:false});
   function endDrag(ev){
     if(!dragging || ev&&ev.pointerId!==dragging.id)return;
     var prev=dragging;
     dragging=null;
     if(prev.moved){
       lastClickBlock=performance.now()+250;
       try{if(track.hasPointerCapture(prev.id))track.releasePointerCapture(prev.id);}catch(e){}
       track.classList.remove('is-flatoo-dragging');
       refresh(root,track);
     }
   }
   track.addEventListener('pointerup',endDrag);
   track.addEventListener('pointercancel',endDrag);
   track.addEventListener('lostpointercapture',endDrag);
   window.addEventListener('pointerup',endDrag,{passive:true});
   track.addEventListener('click',function(ev){
     if(ev.detail>0&&performance.now()<lastClickBlock){
       ev.preventDefault();ev.stopImmediatePropagation();
     }
   },true);
   track.addEventListener('dragstart',function(ev){
     if(ev.target.closest('img,a'))ev.preventDefault();
   });
   if(window.ResizeObserver){
     var ro=new ResizeObserver(function(){refresh(root,track);});
     ro.observe(track);
   }
   refresh(root,track);
 }
 function scan(){
   document.querySelectorAll(selector).forEach(install);
 }
 function schedule(){
   if(queued)return;
   queued=true;
   requestAnimationFrame(function(){queued=false;scan();});
 }
 document.addEventListener('click',function(ev){
   var btn=ev.target.closest('[data-flatoo-popular-direction]');
   if(!btn)return;
   var root=btn.closest(selector),track=root&&root.querySelector('.flatoo-same-category-native-track');
   if(!track)return;
   var card=track.querySelector(':scope > .product');
   var gap=parseFloat(getComputedStyle(track).columnGap)||0;
   var distance=card?card.getBoundingClientRect().width+gap:track.clientWidth*0.8;
   track.scrollBy({left:Number(btn.dataset.flatooPopularDirection)*distance,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
 var main=document.querySelector('main')||document.body;
 if(main)new MutationObserver(function(records){
   for(var i=0;i<records.length;i++){
     if(records[i].addedNodes.length){schedule();break;}
   }
 }).observe(main,{childList:true,subtree:true});
 window.addEventListener('resize',schedule,{passive:true});
 document.addEventListener('shopify:section:load',schedule);
})();
